/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandTidal = createReactComponent("brand-tidal", "IconBrandTidal", [
  [
    "path",
    {
      d: "M5.333 6l3.334 3.25l3.333 -3.25l3.333 3.25l3.334 -3.25l3.333 3.25l-3.333 3.25l-3.334 -3.25l-3.333 3.25l3.333 3.25l-3.333 3.25l-3.333 -3.25l3.333 -3.25l-3.333 -3.25l-3.334 3.25l-3.333 -3.25z",
      key: "svg-0"
    }
  ]
]);

export { IconBrandTidal as default };
//# sourceMappingURL=IconBrandTidal.js.map
